import { http } from '@shared/libs/http'

export type ChangePasswordRequest = { current_password: string; new_password: string }
export async function changePassword(body: ChangePasswordRequest) {
  await http.post('/auth/change-password', body)
}

